export const AUTH_REDUCER_SET_AUTH_DATA = "auth_reducer_set_auth_data";
export const AUTH_REDUCER_SET_AUTH_DATA_SUCCESS = "auth_reducer_set_auth_data_success";
export const AUTH_REDUCER_REMOVE_AUTH_DATA = "auth_reducer_remove_auth_data";

export const NAV_REDUCER_GET_NAV_DATA = "nav_reducer_get_nav_data";

export const PROPERTY_REDUCER_CREATE_PROPERTY = "property_reducer_create_property";
export const PROPERTY_REDUCER_UPDATE_PROPERTY = "property_reducer_update_property";
export const PROPERTY_REDUCER_GET_ALL_PROPERTY = "property_reducer_get_all_property";

export const PROPERTY_REDUCER_GET_ALL_PROPERTY_LITE = "property_reducer_get_all_property_lite";
export const PROPERTY_REDUCER_UPDATE_PROPERTY_STATUS = "property_reducer_update_property_status";
export const PROPERTY_REDUCER_GET_PROPERTY_BY_ID = "property_reducer_get_property_by_id";
export const PROPERTY_REDUCER_GET_ALL_PROPERTY_TYPE = "property_reducer_get_all_property_type";

export const PROPERTY_REDUCER_GET_ALL_CATEGORY = "property_reducer_get_all_category";
export const PROPERTY_REDUCER_CREATE_NEW_CATEGORY = "property_reducer_create_new_category";
export const PROPERTY_REDUCER_UPDATE_CATEGORY = "property_reducer_update_category";

export const PROPERTY_REDUCER_GET_ALL_TAG = "property_reducer_get_all_tag";
export const PROPERTY_REDUCER_CREATE_NEW_TAG = "property_reducer_create_new_tag";
export const PROPERTY_REDUCER_UPDATE_TAG = "property_reducer_update_tag";

export const PROPERTY_REDUCER_GET_ALL_SEARCH_INDEX = "property_reducer_get_all_search_index";
export const PROPERTY_REDUCER_UPDATE_SEARCH_INDEX = "property_reducer_update_search_index";

export const PROPERTY_REDUCER_GET_SINGLE_PROPERTY = "property_reducer_get_single_property";

export const PROPERTY_REDUCER_GET_ALL_DISTRICT = "property_reducer_get_all_district";
export const PROPERTY_REDUCER_UPLOAD_IMAGES = "property_reducer_upload_images";

export const USER_REDUCER_GET_ALL_USERS = "userReducerGetAllUsers";
export const USER_REDUCER_CREATE = "userReducerGetCreate";
export const USER_REDUCER_UPDATE = "userReducerGetUpdate";
export const USER_REDUCER_DELETE = "userReducerGetDelete";

export const HOME_SECTIONS_REDUCER_GET_ALL = "homeSectionsReducerGetAll";
export const HOME_SECTIONS_REDUCER_CREATE = "homeSectionsReducerCreate";
export const HOME_SECTIONS_REDUCER_UPDATE = "homeSectionsReducerUpdate";
export const HOME_SECTIONS_REDUCER_DELETE = "homeSectionsReducerDelete";

export const ADVERT_REDUCER_GET_ALL_CONFIG = "getAllAdvertConfig";
export const ADVERT_REDUCER_GET_ALL = "getAllAdvert";
export const ADVERT_REDUCER_CREATE = "createAdvert";
export const ADVERT_REDUCER_UPDATE = "updateAdvert";
export const ADVERT_REDUCER_DELETE = "deleteAdvert";

export const CONTACT_REQUEST_GET_ALL = "getAllContactRequest";
export const CONTACT_REQUEST_DELETE = "deleteContactRequest";

export const IMAGE_RESOURCES_REDUCER_GET = "imageResourcesReducerGet";
export const IMAGE_RESOURCES_REDUCER_DELETE = "imageResourcesReducerDelete";
export const IMAGE_RESOURCES_REDUCER_CREATE = "imageResourcesReducerCreate";

export const IMAGE_HOST = "https://jorooms.com/hotel-images/";

export const STORAGE_KEY_AUTH_DATA = "auth_data";

export const TOKEN_STORAGE_KEY = "ar_token";
